import { useState, useEffect } from "react";
import PropTypes from "prop-types";

const BandGallery = ({ images = [], bandName }) => {
  const [activeImg, setActiveImg] = useState(images.length > 0 ? images[0] : null);

  useEffect(() => {
    if (images.length > 0) {
      setActiveImg(images[0]);
    }
  }, [images]);

  if (!images || images.length === 0) {
    return <p className="text-center text-lg font-semibold">Kuvia ei ole saatavilla.</p>;
  }

  return (
    <div className="max-w-6xl mx-auto px-4 flex flex-col items-center">
      <h3
        className="
          font-customFont2 dark:text-shadow-lg
          text-center text-darkest dark:text-primary
          text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl
          2xl:text-6xl font-bold leading-tight mb-4
        "
      >
        Kuvagalleria
      </h3>

      {/* Pääkuva */}
      {activeImg && (
        <div className="w-full max-w-[900px] mx-auto mb-6">
          <img
            src={activeImg}
            alt={`${bandName} pääkuva`}
            className="w-full h-auto max-h-[600px] object-contain rounded-lg"
          />
        </div>
      )}

      {/* Pikkukuvat flexissä */}
      <div className="flex flex-wrap justify-center gap-4">
        {images.map((imgUrl, idx) => (
          <button
            key={idx}
            onClick={() => setActiveImg(imgUrl)}
            className="w-24 h-24 sm:w-32 sm:h-32 overflow-hidden rounded-md shadow-lg focus:outline-none"
          >
            <img
              src={imgUrl}
              alt={`${bandName} galleria kuva #${idx + 1}`}
              className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

BandGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  bandName: PropTypes.string.isRequired,
};

export default BandGallery;
